export type ValidatePlanColumn = {
    key: string;
    label: string;
};

// Structured cell value for constraint violations
export type ValidatePlanCellValue = {
    observedValue: number | string | number[] | string[] | null;
    expectedValue?: {
        type: 'value' | 'range' | 'enum';
        min?: number | null;
        max?: number | null;
        recommendedValue?: number | null;
        allowedValues?: (string | number)[] | null;
        disallowedValues?: (string | number)[] | null;
    };
    hasExpectedValue?: boolean;
};

export type ValidatePlanRow = {
    [key: string]: string | number | null | ValidatePlanCellValue;
};

// Type guard to check if a cell value is a structured violation value
export const isStructuredCellValue = (value: any): value is ValidatePlanCellValue => {
    return value !== null && typeof value === 'object' && 'observedValue' in value;
};

export type ValidatePlanTable = {
    id: string;
    title?: string;
    columns: ValidatePlanColumn[];
    rows: ValidatePlanRow[];
};

export type ValidatePlanSectionMetadata = {
    max_concurrent_tprs?: number;
    max_concurrent_fd_fbd?: number;
    [key: string]: string | number | undefined;
};

export type ValidatePlanSection = {
    id: string;
    title: string;
    severity?: 'error' | 'warning' | 'info';
    metadata?: ValidatePlanSectionMetadata;
    tables: ValidatePlanTable[];
};

export type ValidatePlanResponse = {
    validatePlan: {
        sections: ValidatePlanSection[];
    };
};
